// components/ReportTable.js
// Propósito: Mostrar listas de vulnerabilidades, advertencias y mejoras.
// Por qué: Estructurar la salida en bloques identificables y coloreados.

import React from 'react';

function Section({ title, items = [], severity = 'secondary' }) {
  return (
    <div className="mb-4 section-card glass-card">
      <h5 className="section-title">
        <span className={`badge bg-${severity} me-2`}>{title}</span>
        <small className="text-muted">({items.length})</small>
      </h5>
      {items.length === 0 ? (
        <div className="text-muted empty-state glass-card-lite">Sin elementos</div>
      ) : (
        <div className="list-group findings-list">
          {items.map((it, idx) => {
            const variant = mapSeverity(it.severity);
            return (
              <div key={idx} className={`list-group-item finding-item severity-${variant}`}>
                <div className="d-flex justify-content-between align-items-start">
                  <strong className="finding-title">{it.type || 'item'}</strong>
                  {it.severity && (
                    <span className={`badge bg-${variant}`}>{it.severity}</span>
                  )}
                </div>
                <div className="finding-message">{it.message || 'Detalle no especificado'}</div>
                {it.recommendation && (
                  <div className="finding-reco text-muted small">{it.recommendation}</div>
                )}
                {it.details && (
                  <pre className="mt-2 small finding-details">{formatDetails(it.details)}</pre>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function mapSeverity(s) {
  switch (String(s).toLowerCase()) {
    case 'high':
    case 'critical':
    case 'red':
      return 'danger';
    case 'medium':
    case 'yellow':
      return 'warning';
    case 'low':
    case 'green':
    default:
      return 'success';
  }
}

function formatDetails(details) {
  try {
    return typeof details === 'string' ? details : JSON.stringify(details, null, 2);
  } catch {
    return String(details);
  }
}

function ReportTable({ vulnerabilities = [], warnings = [], improvements = [] }) {
  return (
    <div>
      <Section title="Vulnerabilidades" items={vulnerabilities} severity="danger" />
      <Section title="Advertencias" items={warnings} severity="warning" />
      <Section title="Mejoras" items={improvements} severity="success" />
    </div>
  );
}

export default ReportTable;
